/* Homellence · V11b (05.10.2026) – Laufband: Bilder zuverlässig und früh laden.

   Ursache des Kundenfehlers (Chrome, kaputtes Bildsymbol auf „120 cm · Weiß“):
   Alle Karten laden mit loading="lazy", das Band verschiebt sich aber per
   transform. Bilder außerhalb des sichtbaren Ausschnitts starten erst, wenn die
   Karte hereinläuft; schlägt diese eine Anfrage fehl (kurzer Netzabbruch,
   abgebrochene Anfrage), bleibt das Bild kaputt, denn Chrome versucht es nicht
   erneut. Dieses Skript
   1. lädt alle Kartenbilder, sobald das Band in die Nähe kommt (2 Bildschirme),
      außer bei „Datensparen“,
   2. versucht fehlgeschlagene Bilder bis zu dreimal neu (mit Wartezeit und einem
      Zusatzparameter, damit kein zwischengespeicherter Fehler zurückkommt),
   3. versteckt ein Bild, das endgültig fehlschlägt, statt ein kaputtes
      Bildsymbol zu zeigen. */
(function () {
  'use strict';

  var MAX_TRY = 3;

  function withParam(url, n) {
    if (!url) return url;
    return url.replace(/([?&])hlr=\d+&?/, '$1').replace(/[?&]$/, '') + (url.indexOf('?') > -1 ? '&' : '?') + 'hlr=' + n;
  }

  function retry(img) {
    var n = parseInt(img.getAttribute('data-hl-try') || '0', 10);
    if (n >= MAX_TRY) { img.classList.add('is-broken'); return; }
    img.setAttribute('data-hl-try', String(n + 1));
    window.setTimeout(function () {
      var ss = img.getAttribute('srcset');
      var src = img.getAttribute('src');
      if (ss) {
        img.setAttribute('srcset', ss.split(',').map(function (part) {
          var bits = part.trim().split(/\s+/);
          bits[0] = withParam(bits[0], n + 1);
          return bits.join(' ');
        }).join(', '));
      }
      if (src) img.setAttribute('src', withParam(src, n + 1));
    }, 500 * Math.pow(2, n));
  }

  function watch(img) {
    if (img.__hlWatched) return;
    img.__hlWatched = true;
    img.addEventListener('error', function () { retry(img); });
    img.addEventListener('load', function () { img.classList.remove('is-broken'); });
    if (img.complete && img.naturalWidth === 0 && (img.getAttribute('src') || img.currentSrc) && img.loading !== 'lazy') retry(img);
  }

  function eagerAll(root) {
    var saver = navigator.connection && navigator.connection.saveData;
    Array.prototype.forEach.call(root.querySelectorAll('.hl-lb-card__img'), function (img) {
      watch(img);
      if (!saver && img.loading === 'lazy') img.loading = 'eager';
      img.decoding = 'async';
    });
  }

  function init(root) {
    if (root.__hlRobust) return;
    root.__hlRobust = true;
    var track = root.querySelector('[data-lb-track]');
    var go = function () { eagerAll(root); };

    /* Klone, die das Band später anlegt, bekommen dasselbe */
    if (track && 'MutationObserver' in window) {
      new MutationObserver(function () { eagerAll(root); }).observe(track, { childList: true });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); go(); }
      }, { rootMargin: '1600px 0px 1600px 0px' });
      io.observe(root);
    } else {
      go();
    }

    /* Bilder, die schon vor diesem Skript fehlgeschlagen sind */
    Array.prototype.forEach.call(root.querySelectorAll('.hl-lb-card__img'), watch);
    window.addEventListener('load', function () {
      Array.prototype.forEach.call(root.querySelectorAll('.hl-lb-card__img'), function (img) {
        if (img.complete && img.naturalWidth === 0 && img.loading !== 'lazy') retry(img);
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('hl-laufband'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
